module.exports = __webpack_public_path__ + "img/4.91e5e736.jpg";